var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRealTimeUpdates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m40.219 129.151h365.202c22.12 0 40.219 18.098 40.219 40.219v162.069c0 22.12-18.099 40.219-40.219 40.219h-272.874l-72.102 72.102v-72.102h-20.226c-22.121 0-40.219-18.099-40.219-40.219v-162.069c0-22.12 18.098-40.219 40.219-40.219z",
    fill: "#518ef8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.044 225.297c6.936 0 13.202 2.798 17.748 7.344 4.547 4.546 7.345 10.842 7.345 17.749 0 6.936-2.798 13.231-7.345 17.749-4.546 4.546-10.812 7.373-17.748 7.373s-13.203-2.827-17.749-7.373c-4.546-4.517-7.345-10.812-7.345-17.749 0-6.907 2.798-13.202 7.345-17.749 4.546-4.546 10.813-7.344 17.749-7.344z",
    fill: "#eaf2ff"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m21.071 144.831h182.149 15.767 23.432 143.884c22.12 0 40.219 18.098 40.219 40.219v162.098c0 7.985-2.361 15.446-6.412 21.741 14.921-5.916 25.53-20.488 25.53-37.45v-162.069c0-22.12-18.099-40.219-40.219-40.219h-163.002-23.432-15.767-163.001c-14.135 0-26.638 7.373-33.807 18.477 4.546-1.806 9.5-2.797 14.659-2.797z",
    fill: "#3478ed",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.834 225.297c6.907 0 13.203 2.798 17.749 7.344 4.517 4.546 7.344 10.842 7.344 17.749 0 6.936-2.827 13.231-7.344 17.749-4.546 4.546-10.842 7.373-17.749 7.373-6.936 0-13.231-2.827-17.777-7.373-4.518-4.517-7.345-10.812-7.345-17.749 0-6.907 2.827-13.202 7.345-17.749 4.546-4.546 10.841-7.344 17.777-7.344z",
    fill: "#eaf2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.595 225.297c6.936 0 13.202 2.798 17.749 7.344 4.546 4.546 7.344 10.842 7.344 17.749 0 6.936-2.798 13.231-7.344 17.749-4.547 4.546-10.812 7.373-17.749 7.373s-13.202-2.827-17.748-7.373c-4.547-4.517-7.345-10.812-7.345-17.749 0-6.907 2.798-13.202 7.345-17.749 4.546-4.546 10.812-7.344 17.748-7.344z",
    fill: "#eaf2ff"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m445.639 200.933c36.546 0 66.361-29.785 66.361-66.331s-29.814-66.361-66.361-66.361c-36.517 0-66.332 29.814-66.332 66.361.001 36.546 29.815 66.331 66.332 66.331z",
    fill: "#ed1b24",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealTimeUpdates);
export default __webpack_public_path__ + "static/media/real-time-updates.38e03d1bbad19057505d0b7cb0105055.svg";
export { ForwardRef as ReactComponent };